import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { MostSoldCategoriesResponse } from '../models/models'

export class MostSoldCategoriesApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/product/MostSoldCategories',
      requesterInfo,
    })
  }

  public async mostSoldCategories(): Promise<MostSoldCategoriesResponse[]> {
    return await this.getAsync<MostSoldCategoriesResponse[]>()
  }
}
